/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Th6Inputs */

const en_mk_cmp_clickup_th6 = /** @type {(inputs: Mk_Cmp_Clickup_Th6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very broad: docs, whiteboards, goals, forms, time tracking.`)
};

const id_mk_cmp_clickup_th6 = /** @type {(inputs: Mk_Cmp_Clickup_Th6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sangat luas: dokumen, papan tulis, tujuan, formulir, pelacak waktu.`)
};

/**
* | output |
* | --- |
* | "Very broad: docs, whiteboards, goals, forms, time tracking." |
*
* @param {Mk_Cmp_Clickup_Th6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_th6 = /** @type {((inputs?: Mk_Cmp_Clickup_Th6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Th6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_th6(inputs)
	return en_mk_cmp_clickup_th6(inputs)
});